import * as React from "react";
import {LocationProvider} from "./src/context/LocationContext";
import {LocaleProvider} from "./src/context/LocaleContext";
import "bootstrap/dist/js/bootstrap.min.js";
import "@popperjs/core/dist/umd/popper.min.js";

export const wrapPageElement = ({element, props}) => {
  const {location} = props;
  const {locale} = element.props.pageContext;

  return (
    <LocationProvider location={location}>
      <LocaleProvider locale={locale}>
        {element}
      </LocaleProvider>
    </LocationProvider>
  );
};

export const onInitialClientRender = () => {
  // defer import until Gatsby has hydrated
  import("./src/analytics/init-ga").then(m => m.default());
  import("./src/analytics/init-fb").then(m => m.default());
};

export const onRouteUpdate = ({ location }) => {
  if (window.fbq) {
    window.fbq("track", "PageView");
  }

  try {
    const { trackRoutePageView } = require("./src/analytics/route-page-view");
    trackRoutePageView(location);
  } catch (_e) {
    // no-op: analytics must never break navigation
  }
};
